export const videosFake = 
[
    {
        id : {
            videoId : 'GDa8kZLNhJ4' ,
        } ,
        snippet:{
            channelId:'....' ,
            thumbnails:{
                high : {
                    url: 'https://vnreview.vn/image/20/12/02/2012029.jpg' ,
                }
            } ,
            title: 'This is title of video' ,
        }
    } ,
]
